import { State } from '../../types';

export const kentucky: State = {
  name: 'Kentucky',
  abbreviation: 'KY',
  terms: [
    {
      word: 'Athens',
      phonetic: 'AY-thins',
      // audioUrl: '/audio/louisville.mp3',
      description: 'A small community, often mispronounced as ATH-ens.'
    },
    {
      word: 'Bellarmine',
      phonetic: 'BELL-ur-min',
      // audioUrl: '/audio/louisville.mp3',
      description: 'A university in Louisville, often mispronounced as BELL-ar-mine.'
    },
    {
      word: 'Buechel',
      phonetic: 'BYOO-chul',
      // audioUrl: '/audio/louisville.mp3',
      description: 'A neighborhood in Louisville, mispronounced as BYOO-chell and other ways.'
    },
    {
      word: 'Cadiz',
      phonetic: 'KAY-diz',
      // audioUrl: '/audio/cadiz.mp3',
      description: 'A city in Trigg County, pronounced "KAY-diz," not like the Spanish city "KAH-deez."'
    },
    {
      word: 'Daviess',
      phonetic: 'DAY-viss',
      // audioUrl: '/audio/daviess.mp3',
      description: 'A county in Kentucky, pronounced "DAY-viss," not "Duh-VEESE."'
    },
    {
      word: 'Louisville',
      phonetic: 'LOO-uh-vul',
      // audioUrl: '/audio/louisville.mp3',
      description: 'Largest city in Kentucky'
    },
    {
      word: 'Mike Linnig’s',
      phonetic: 'Mike LINN-ings',
      // audioUrl: '/audio/louisville.mp3',
      description: 'A popular seafood restaurant named Mike LINN-igs but the locals call it Mike LINN-ings.'
    },
    {
      word: 'Tyewhoppety',
      phonetic: 'Tih-WAH-pih-tee',
      // audioUrl: '/audio/louisville.mp3',
      description: 'A town in Kentucky'
    },
    {
      word: 'Versailles',
      phonetic: 'ver-SALES',
      // audioUrl: '/audio/versailles-ky.mp3',
      description: 'City in central Kentucky'
    }
  ]
};